module.exports = __webpack_public_path__ + "static/media/pallet-alt.66917b3c.svg";